// // utils/mapUtils.js

// /**
//  * Ensure Google Maps is loaded
//  */
// const ensureGoogle = () => {
//   if (!window.google || !window.google.maps) {
//     throw new Error("Google Maps JS API not loaded");
//   }
// };

// /**
//  * Places Autocomplete (SAFE)
//  */
// export const getPlacePredictions = (input) => {
//   return new Promise((resolve) => {
//     try {
//       ensureGoogle();

//       const service = new window.google.maps.places.AutocompleteService();

//       service.getPlacePredictions(
//         {
//           input,
//           componentRestrictions: { country: "in" },
//         },
//         (predictions, status) => {
//           if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//             resolve(predictions);
//           } else {
//             resolve([]);
//           }
//         }
//       );
//     } catch (err) {
//       console.error(err);
//       resolve([]);
//     }
//   });
// };

// /**
//  * Place Details (SAFE)
//  */
// export const getPlaceDetails = (placeId) => {
//   return new Promise((resolve) => {
//     try {
//       ensureGoogle();

//       const service = new window.google.maps.places.PlacesService(
//         document.createElement("div")
//       );

//       service.getDetails(
//         {
//           placeId,
//           fields: ["name", "formatted_address", "geometry", "address_components"],
//         },
//         (result, status) => {
//           if (
//             status !== window.google.maps.places.PlacesServiceStatus.OK ||
//             !result
//           ) {
//             resolve(null);
//             return;
//           }

//           const components = {};
//           result.address_components.forEach((c) => {
//             c.types.forEach((t) => (components[t] = c.long_name));
//           });

//           resolve({
//             name: result.name,
//             address: result.formatted_address,
//             coordinates: {
//               lat: result.geometry.location.lat(),
//               lng: result.geometry.location.lng(),
//             },
//             city:
//               components.locality ||
//               components.administrative_area_level_2 ||
//               "",
//             state: components.administrative_area_level_1 || "",
//             placeId,
//           });
//         }
//       );
//     } catch (err) {
//       console.error(err);
//       resolve(null);
//     }
//   });
// };

// /**
//  * Browser Geolocation (SAFE)
//  */
// export const getCurrentLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (!navigator.geolocation) {
//       reject("Geolocation not supported");
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         resolve({
//           lat: pos.coords.latitude,
//           lng: pos.coords.longitude,
//         });
//       },
//       reject,
//       { enableHighAccuracy: true }
//     );
//   });
// };

// utils/mapUtils.js

/**
 * Ensure Google Maps is loaded
 */
const ensureGoogle = () => {
  if (!window.google || !window.google.maps) {
    throw new Error("Google Maps JS API not loaded");
  }
};

/**
 * Places Autocomplete (SAFE)
 */
export const getPlacePredictions = (input) => {
  return new Promise((resolve) => {
    try {
      ensureGoogle();

      const service = new window.google.maps.places.AutocompleteService();

      service.getPlacePredictions(
        {
          input,
          componentRestrictions: { country: "in" },
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
          } else {
            resolve([]);
          }
        }
      );
    } catch (err) {
      console.error(err);
      resolve([]);
    }
  });
};

/**
 * Place Details (SAFE)
 */
export const getPlaceDetails = (placeId) => {
  return new Promise((resolve) => {
    try {
      ensureGoogle();

      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );

      service.getDetails(
        {
          placeId,
          fields: ["name", "formatted_address", "geometry", "address_components"],
        },
        (result, status) => {
          if (
            status !== window.google.maps.places.PlacesServiceStatus.OK ||
            !result
          ) {
            resolve(null);
            return;
          }

          const components = {};
          result.address_components.forEach((c) => {
            c.types.forEach((t) => (components[t] = c.long_name));
          });

          resolve({
            name: result.name,
            address: result.formatted_address,
            coordinates: {
              lat: result.geometry.location.lat(),
              lng: result.geometry.location.lng(),
            },
            city:
              components.locality ||
              components.administrative_area_level_2 ||
              "",
            state: components.administrative_area_level_1 || "",
            placeId,
          });
        }
      );
    } catch (err) {
      console.error(err);
      resolve(null);
    }
  });
};

/**
 * Browser Geolocation (SAFE)
 */
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          address: {
            name: "Current Location",
            address: `${pos.coords.latitude}, ${pos.coords.longitude}`,
            city: "",
            state: "",
            placeId: ""
          },
          coordinates: {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude
          }
        });
      },
      reject,
      { enableHighAccuracy: true }
    );
  });
};

/**
 * Get Distance Matrix between multiple origins and destinations
 * Uses Google Maps Distance Matrix API
 */
export const getDistanceMatrix = (origins, destinations) => {
  return new Promise((resolve, reject) => {
    try {
      ensureGoogle();

      const service = new window.google.maps.DistanceMatrixService();
      
      // Format origins and destinations to Google Maps format
      const formatLocations = (locations) => {
        return locations.map(loc => {
          if (loc.lat && loc.lng) {
            return new window.google.maps.LatLng(loc.lat, loc.lng);
          }
          return loc.name || loc.address || loc.city || "";
        });
      };

      const formattedOrigins = formatLocations(origins);
      const formattedDestinations = formatLocations(destinations);

      service.getDistanceMatrix(
        {
          origins: formattedOrigins,
          destinations: formattedDestinations,
          travelMode: window.google.maps.TravelMode.DRIVING,
          unitSystem: window.google.maps.UnitSystem.METRIC,
        },
        (response, status) => {
          if (status === window.google.maps.DistanceMatrixStatus.OK) {
            resolve(response);
          } else {
            reject(new Error(`Distance Matrix API error: ${status}`));
          }
        }
      );
    } catch (err) {
      console.error("Distance Matrix error:", err);
      reject(err);
    }
  });
};

/**
 * Calculate distance between two points using Haversine formula (fallback)
 */
export const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};